var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isBriocheImage
    ? _c(
        "img",
        _vm._b({ attrs: { alt: _vm.alt } }, "img", _vm.elementAttributes, false)
      )
    : _c(
        "ResponsiveImage",
        _vm._b(
          { attrs: { alt: _vm.alt } },
          "ResponsiveImage",
          _vm.elementAttributes,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }